import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-2 grid formgrid"
}
const _hoisted_2 = { class: "col p-fluid field pt-3" }
const _hoisted_3 = { class: "col-2 md:col-1" }
const _hoisted_4 = { class: "col-12 mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "bg-white border-rounded opacity-80 font-bold p-2"
}
const _hoisted_6 = { class: "text-lg" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-lg" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "p-float-label mt-5" }
const _hoisted_13 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_control = _resolveComponent("l-control")!
  const _component_l_polyline = _resolveComponent("l-polyline")!
  const _component_l_icon = _resolveComponent("l-icon")!
  const _component_l_tooltip = _resolveComponent("l-tooltip")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_l_circle_marker = _resolveComponent("l-circle-marker")!
  const _component_l_map = _resolveComponent("l-map")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.showDetail === false)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Slider, {
            modelValue: _ctx.progress,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.progress) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createVNode(_component_Button, {
            icon: _ctx.autoPlay ? 'pi pi-pause' : 'pi pi-play',
            class: _normalizeClass(_ctx.autoPlay ? 'p-button-warning' : 'p-button-success'),
            onClick: _ctx.togglePlay
          }, null, 8, ["icon", "class", "onClick"]), [
            [_directive_tooltip, `แสดงการเดินทาง`]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.userLocations.length > 0 || _ctx.customerLocationOnMap.length > 0)
            ? (_openBlock(), _createBlock(_component_l_map, {
                key: 0,
                center: _ctx.mapCenter,
                zoom: 13,
                bounds: _ctx.mapBound,
                style: {"height":"80vh"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_l_tile_layer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
                  _createVNode(_component_l_control, { position: "topright" }, {
                    default: _withCtx(() => [
                      (_ctx.latestTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " เวลา " + _toDisplayString(_ctx.formatDateTime(_ctx.latestTime)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_l_polyline, {
                    "lat-lngs": _ctx.routes,
                    color: "red"
                  }, null, 8, ["lat-lngs"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerLocationOnMap, (customerLocation, index) => {
                    return (_openBlock(), _createBlock(_component_l_marker, {
                      key: `k-${index}`,
                      "lat-lng": [customerLocation.latitude, customerLocation.longitude]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_l_icon, {
                          "icon-url": _ctx.iconUrl(customerLocation),
                          "icon-size": _ctx.dynamicSize,
                          "icon-anchor": _ctx.dynamicAnchor
                        }, null, 8, ["icon-url", "icon-size", "icon-anchor"]),
                        _createVNode(_component_l_tooltip, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, " ลำดับที่ : " + _toDisplayString(customerLocation.sequence), 1),
                            _createElementVNode("div", null, _toDisplayString(customerLocation.customerName) + " (" + _toDisplayString(customerLocation.customerNo) + " ) ", 1),
                            (customerLocation.deliverOn)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " จัดส่งเมื่อ : " + _toDisplayString(_ctx.formatDateTime(customerLocation.deliverOn)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["lat-lng"]))
                  }), 128)),
                  (_ctx.truckPosition)
                    ? (_openBlock(), _createBlock(_component_l_marker, {
                        key: 0,
                        "lat-lng": _ctx.truckPosition
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_l_icon, {
                            "icon-url": "icons/truck_icon.png",
                            "icon-size": _ctx.truckDynamicSize,
                            "icon-anchor": _ctx.truckDynamicAnchor
                          }, null, 8, ["icon-size", "icon-anchor"])
                        ]),
                        _: 1
                      }, 8, ["lat-lng"]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stillPoints, (still, index) => {
                    return (_openBlock(), _createBlock(_component_l_circle_marker, {
                      key: `s-${index}`,
                      "lat-lng": [still.latitude, still.longitude],
                      radius: still.minutes / 2,
                      color: still.minutes < 60 ? 'orange' : 'red',
                      fill: true,
                      "fill-color": still.minutes < 60 ? 'orange' : ''
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_l_tooltip, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, "จุดจอดนาน " + _toDisplayString(still.minutes) + " นาที", 1),
                            _createElementVNode("div", null, " เริ่ม " + _toDisplayString(_ctx.formatTime(still.start)) + " จนถึง " + _toDisplayString(_ctx.formatTime(still.end)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["lat-lng", "radius", "color", "fill-color"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["center", "bounds"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_InputText, {
                id: "searchString",
                class: "p-inputtext-sm",
                modelValue: _ctx.searchString,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchString) = $event))
              }, null, 8, ["modelValue"]),
              _cache[2] || (_cache[2] = _createElementVNode("label", { for: "searchString" }, "ค้นหา", -1)),
              _createVNode(_component_Button, {
                icon: "pi pi-download",
                class: "p-button-sm p-button-success",
                label: "Excel",
                onClick: _ctx.onDownloadExcel,
                disabled: _ctx.filteredCustomerLocations.length === 0
              }, null, 8, ["onClick", "disabled"])
            ])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", null, "* ค้นหาด้วย รหัสร้านค้า, ชื่อร้านค้า, รหัส Delivery Order", -1)),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_DataTable, {
              value: _ctx.filteredCustomerLocations,
              sortMode: "multiple",
              class: "p-datatable-sm"
            }, {
              empty: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("ไม่พบข้อมูล")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "deliveryDate",
                  header: "วันที่จัดส่ง",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    (props.data.deliveryDate)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(props.data.deliveryDate)), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("???")
                        ], 64))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "shipmentNo",
                  header: "เลขที่ Shipment",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(parseInt(props.data.shipmentNo)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "saleoffice",
                  header: "Sale office",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "customerNo",
                  header: "รหัสร้านค้า",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(parseInt(props.data.customerNo)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "customerName",
                  header: "ร้านค้า",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "deliveryNo",
                  header: "รหัส Delivery Order",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "sequence",
                  header: "ลำดับการส่ง",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "deliverOn",
                  header: "ยืนยันการชำระเงิน",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    (props.data.deliverOn)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateTime(props.data.deliverOn)), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("ยังไม่ได้จัดส่ง")
                        ], 64))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "checkin_dt",
                  header: "เวลา check in",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    (props.data.checkin_dt)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateTime(props.data.checkin_dt)), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("ยังไม่ได้ check in")
                        ], 64))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "checkout_dt",
                  header: "เวลา check out",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    (props.data.checkout_dt)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateTime(props.data.checkout_dt)), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("ยังไม่ได้ check out")
                        ], 64))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "serviceTime",
                  header: "เวลาที่ใช้",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    (props.data.checkout_dt)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(props.data.serviceTime) + " นาที ", 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "caseAmount",
                  header: "จำนวนลัง",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    (props.data.caseAmount)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(props.data.caseAmount) + " ลัง ", 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ])
      ]))
}